import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { AGUAppLocation } from '../../app-surface/app-location';
import type { AGUCrumbItem } from './crumb.labels';

/**
 * The crumb trail (`nav.crumb`, P/detail.html:265-269, 888; `.cx-crumb`, P/06_career-explorer.html:268-272, 1571-1576): every
 * ancestor a button named "Back to {Label}" (P/detail.html:1083), the first with the back glyph, `/` separators, and the page on
 * screen in bold. It replaced the three detail views' "Back to …" pills: the first ancestor is wherever the member came from
 * (`AGUAppLocation.From`), not always the finder.
 *
 * Navigation is the host's business: the crumb only emits the ancestor's location.
 */
@Component({
    standalone: false,
    selector: 'agu-crumb',
    templateUrl: './crumb.component.html',
    styleUrl: './crumb.component.scss',
})
export class AGUCrumbComponent {
    /** Ancestors first, the current page (no location) last. */
    @Input({ required: true }) Trail: readonly AGUCrumbItem[] = [];

    @Output() Navigate = new EventEmitter<AGUAppLocation>();

    /** The ancestor's accessible name (P/detail.html:1083: `'Back to ' + label`). */
    AriaLabel(item: AGUCrumbItem): string {
        return `Back to ${item.Label}`;
    }

    Go(item: AGUCrumbItem): void {
        if (item.Location) this.Navigate.emit(item.Location);
    }
}
